module.exports = __webpack_public_path__ + "pc/img/about_sens.285afa63.png";